import { z } from "zod";
import { normalizeReminderSmsPhone } from "./sms.js";
export const SCHEDULED_REMINDER_STATUSES = [
    "scheduled",
    "processing",
    "sent",
    "cancelled",
    "auto_cancelled",
    "failed",
];
export const ACTIVE_SCHEDULED_REMINDER_STATUSES = ["scheduled", "processing"];
const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
/**
 * `remainingRelaunches` n'accepte que 0/1/2 (PRD) — jamais de `.default()` sur
 * ce schéma partagé (une valeur omise doit rester omise pour l'appelant, pas
 * silencieusement réécrite avant `ZodValidationPipe`).
 */
export const CreateScheduledReminderPayloadSchema = z
    .object({
    customerId: z.string().trim().min(1),
    sourceEventId: z.string().trim().min(1).nullable().optional(),
    scheduledDate: z.string().regex(DATE_ONLY_REGEX, "Expected YYYY-MM-DD"),
    remainingRelaunches: z.union([z.literal(0), z.literal(1), z.literal(2)]).optional(),
    channelEmail: z.boolean().optional(),
    channelSms: z.boolean().optional(),
    smsConsentAttested: z.boolean().optional(),
    smsConsentPhone: z.string().optional(),
})
    .superRefine((value, ctx) => {
    if (!(value.channelEmail ?? true) && !value.channelSms) {
        ctx.addIssue({
            code: "custom",
            path: ["channelEmail"],
            message: "Choisissez au moins un canal",
        });
    }
    if (value.channelSms && !normalizeReminderSmsPhone(value.smsConsentPhone)) {
        ctx.addIssue({
            code: "custom",
            path: ["smsConsentPhone"],
            message: "Un mobile français valide est requis",
        });
    }
    if (value.channelSms && value.smsConsentAttested !== true) {
        ctx.addIssue({
            code: "custom",
            path: ["smsConsentAttested"],
            message: "Le consentement SMS doit être attesté",
        });
    }
});
export const PreviewReminderDatesPayloadSchema = z.object({
    scheduledDate: z
        .string()
        .regex(DATE_ONLY_REGEX)
        .refine((value) => {
        const date = new Date(`${value}T00:00:00Z`);
        return (Number.isFinite(date.getTime()) &&
            date.toISOString().slice(0, 10) === value &&
            value >= "2000-01-01" &&
            value <= "2100-12-31");
    }, "Choisissez une date valide entre 2000 et 2100"),
    remainingRelaunches: z.union([z.literal(0), z.literal(1), z.literal(2)]),
    channelSms: z.boolean(),
});
//# sourceMappingURL=types.js.map